import Vue from 'vue'
import type { Editor } from '@tiptap/core'
import { RootEntityType } from '@/modules/elements/models/Element'

export interface VariableAssignmentRequest {
  variableName: string
  variableId?: string
  /** The callout the menu anchors to */
  element: HTMLElement
  /** The editor that holds the clicked variable, used for the bulk-assign list and its own refresh */
  editor?: Editor | null
  rootEntityType?: RootEntityType
}

/**
 * Editors whose host does not handle `assign-recipient` itself (table cells, FAQ, timeline, ...) publish the request
 * here; VariableAssignmentProvider (mounted once in App) opens the menu and does the assigning.
 */
export const variableAssignmentBus = Vue.observable({
  request: null as VariableAssignmentRequest | null
})

export function requestVariableAssignment(request: VariableAssignmentRequest): void {
  variableAssignmentBus.request = request
}
